import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { SettingsService } from '../../services/settings.service';
import { AssistantHub } from '../../services/signalr/assistant.hub';

@Component({
  standalone: false,
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoComponent {
  public version: string | undefined;
  public environment: string;
  public TranslationKeys = TranslationKeys;

  public ICONS = ICONS;

  public constructor(
    environmentService: EnvironmentConfigurationService,
    // public readonly callAgentService: CallAgentService,
    public readonly assistantHub: AssistantHub,
    public readonly settingsService: SettingsService,
  ) {
    this.version = environmentService.configurationSettings.releaseVersion;
    this.environment = environmentService.configurationSettings.environmentName;
  }
}
